exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selection-line {\n  transition: opacity 500ms;\n  opacity: 0;\n  z-index: 7500;\n}\n\n.selection-line-appear {\n  opacity: 0;\n}\n\n.selection-line-appear-active {\n  opacity: 1;\n}\n\n.selection-line-enter {\n  opacity: 0;\n}\n\n.selection-line-enter-active {\n  opacity: 1;\n  transition: left 25ms, top 100ms, width 25ms, opacity 500ms;\n}\n\n.selection-line-exit {\n  opacity: 1;\n}\n\n.selection-line-exit-active {\n  opacity: 0;\n}\n\n.selection-line-enter-done {\n  opacity: 1;\n  transition: left 25ms, top 100ms, width 25ms, opacity 500ms;\n}\n", ""]);

// exports
